// Constants transcribed from the AngularJS handheldConfigAddEditController.js so the
// React dialog keeps parity with the legacy option sets, labels, and defaults.

import { DeviceProfileConfig, PreferenceOption, SelectOption, StatusOption } from "./types";

export const STATUSES: StatusOption[] = [
  { name: "On Shelf", value: "onshelf" },
  { name: "Waiting", value: "waiting" },
  { name: "Accepted By Staff", value: "making" },
  { name: "Catering Approved", value: "approved" },
  { name: "Catering Making", value: "catering_making" },
  { name: "Wait for Runner", value: "wait_for_runner" },
  { name: "Wait for Driver", value: "wait_for_driver" },
  { name: "Waiting to be Packaged", value: "ready_for_packer" },
  { name: "Being Packaged", value: "packing" },
];

// Kept alphabetized by name.
export const DEFAULT_PREFERENCE_OPTIONS: PreferenceOption[] = [
  { name: "Android Configuration - Keep Awake On Battery", value: "keep_awake_on_battery" },
  { name: "KDS View - Always Advance Ticket On Tap", value: "kds_always_advance_ticket_on_tap" },
  { name: "KDS View - Always Show Ticket Items", value: "kds_show_waiting" },
  { name: "KDS View - Auto-Focus Current Orders", value: "kds_autofocus" },
  { name: "KDS View - Enable Idle Screen Images", value: "kds_idle_screen" },
  { name: "KDS View - Flash Screen on All Day View", value: "kds_all_day_flash_screen" },
  { name: "KDS View - Hide Extra Checkout Info", value: "kds_hide_checkout_info" },
  { name: "KDS View - High Contrast Colors", value: "kds_use_high_contrast" },
  { name: "KDS View - Show Individual Item Statuses", value: "kds_show_item_status" },
  { name: "KDS View - Show Status Advance Button At The Top Of Tickets", value: "kds_status_advance_top" },
  { name: "KDS View - Split Items by Modifier on All Day View", value: "kds_all_day_grouping_rule" },
  { name: "Quick Re-Order Mode - Return to Order Creation Screen after checkout.", value: "quick_order_mode" },
];

export const KDS_TICKET_ITEM_APPEARANCE_OPTIONS: SelectOption[] = [
  { label: "Default", value: "default" },
  { label: "Expanded", value: "expanded" },
];

// Ordered list of permission actions (drives the User Permissions matrix row order).
// Kept alphabetized by the ACTION_NAMES label below.
export const ACTION_ORDER: string[] = [
  "add_edit_menu_items",
  "allow_refunds",
  "change_profile",
  "manage_reader",
  "manage_inventory",
  "move_item_status_backwards",
  "change_device",
  "reprint_ticket",
  "toggle_fulfillment_method_allowed",
  "toggle_location_order_allowed",
  "toggle_menu_order_allowed",
  "toggle_station_order_allowed",
];

export const ACTION_NAMES: Record<string, string> = {
  toggle_location_order_allowed: "Toggle Ordering By Location",
  toggle_menu_order_allowed: "Toggle Ordering By Menu",
  toggle_station_order_allowed: "Toggle Ordering By Station",
  toggle_fulfillment_method_allowed: "Toggle Ordering By Fulfillment Method",
  move_item_status_backwards: "Move Order Status Backwards",
  allow_refunds: "Allow Refunds",
  change_device: "Rename Device",
  change_profile: "Change Device Profile",
  reprint_ticket: "Reprint Ticket",
  manage_reader: "Manage Credit Card Reader",
  add_edit_menu_items: "Add / Edit Menu Items",
  manage_inventory: "Manage Inventory",
};

// value = level stored on the config, label = human-facing name.
// Kept alphabetized by label.
export const PERMISSION_LEVEL_OPTIONS: SelectOption[] = [
  { value: "Admin", label: "Admin" },
  { value: "Staff", label: "Any Staff" },
  { value: "Bartender", label: "Bartender" },
  { value: "Prompt", label: "Confirm Before Action" },
  { value: "Manager", label: "Manager" },
  { value: "Allow", label: "No Access Restriction" },
  { value: "Owner", label: "Owner" },
  { value: "Server", label: "Server" },
];

export const DEFAULT_PERMISSIONS: Record<string, string> = {
  allow_refunds: "Manager",
  change_device: "Manager",
  change_profile: "Manager",
  toggle_location_order_allowed: "Prompt",
  toggle_menu_order_allowed: "Prompt",
  toggle_station_order_allowed: "Prompt",
  toggle_fulfillment_method_allowed: "Prompt",
  manage_reader: "Prompt",
  move_item_status_backwards: "Prompt",
  reprint_ticket: "Manager",
  add_edit_menu_items: "Manager",
  manage_inventory: "Manager",
};

// Baseline for a brand-new profile (matches the model field defaults; forced_volume_level 1.0).
export const NEW_CONFIG_DEFAULTS: DeviceProfileConfig = {
  config_name: "",
  description: "",
  show_locations_overview: false,
  quick_order_location: null,
  hide_seated_groups: false,
  show_create_order: false,
  use_stripe_chip_reader: false,
  allow_manual_card_entry: false,
  allow_pay_with_consumer_tab: false,
  show_stations_overview: false,
  show_kds_view: false,
  kds_edit_item_status: false,
  show_order_control: false,
  kds_show_prices: false,
  kds_partial_refunds: false,
  kds_group_related_tickets: false,
  show_menu_editor: false,
  show_tip_report: false,
  receive_service_requests: false,
  allow_disabling_chirp: false,
  forced_volume_level: 1,
  permissions: {},
  custom_kds_ticket_colors: {},
  default_preferences: {},
  additional_closed_statuses: [],
  statuses_to_chirp_for: [],
  locations: [],
  stations: [],
  kds_stations: [],
  menus: [],
};
